import { useOrganization } from 'hooks/store';
import { useFeatureFlags } from 'utils/features/hooks';

export default function useEquipmentInspectionsEnabled() {
  const organization = useOrganization();
  return useFeatureFlags('EQUIPMENT_INSPECTIONS') && !!organization.equipmentInspections;
}

export function useEquipmentInspectionsGroupActionsEnabled() {
  const equipmentInspectionsEnabled = useEquipmentInspectionsEnabled();
  const equipmentInspectionsGroupActionsEnabled = useFeatureFlags('EQUIPMENT_INSPECTIONS_GROUP_ACTIONS');
  return equipmentInspectionsEnabled && equipmentInspectionsGroupActionsEnabled;
}
